/** @format */

import { styled } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React from "react";

export default function AutocompleteClient({
  data = [],
  handleChange = () => null,
  value = null,
  name,
  size = "small",
  placeholder = "placeholder",
  accessorKey = "name",
  label = "",
  required = false,
  ...props
}) {
  const options = Array.isArray(data) ? data : [];
  const handleNameSend = (event, newValue) => {
    handleChange(newValue, name);
  };

  return (
    <StyledAutocomplete
      disablePortal
      options={options}
      getOptionLabel={(option) => option?.[accessorKey]}
      fullWidth
      value={value}
      size={size}
      {...props}
      onChange={handleNameSend}
      renderInput={(params) => (
        <TextField {...params} placeholder={placeholder} />
      )}
    />
  );
}

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      display: "none",
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.text.primary,
    },
  },
  "& .MuiAutocomplete-inputRoot": {
    color: theme.palette.text.primary,
    paddingTop: "2px !important",
    paddingBottom: "2px !important",
  },
  "& .MuiAutocomplete-popupIndicator": {
    color: theme.palette.text.primary,
  },
}));
